import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AdsCard from './AdsCard'
import styled from 'styled-components'



const AdsWrapper = styled.div`
display: block;
width: 100%;
max-width: 1000px;
margin: 0 auto;
`
const SectionWrapper = styled.div`
width: ${window.innerWidth};
height: 100%;
padding-bottom: 20vh;

background: linear-gradient(
    to top,
    #FF4C00,
    #FF4C00 52vh,
    transparent 1rem,
    transparent 100%
);
`


export const KitsAdvs = ({props}) =>  {

    const Cards = props.columns.map((data) => {
        return(
            <Col key={data.id}>
            <AdsCard props={data}/>
            </Col>
        )
    })

    return (
        <>
        <SectionWrapper>
        <AdsWrapper>
            <Container fluid>
                <Row xs={2} sm={2} lg={2}>
                    {Cards}
                </Row>
            </Container>
        </AdsWrapper>
        </SectionWrapper>
        </>
    )
}
